import { render, staticRenderFns } from "./Punctuality.vue?vue&type=template&id=06928789&scoped=true"
import script from "./Punctuality.vue?vue&type=script&lang=js"
export * from "./Punctuality.vue?vue&type=script&lang=js"
import style0 from "./Punctuality.vue?vue&type=style&index=0&id=06928789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06928789",
  null
  
)

export default component.exports